import { NgModule } from "@angular/core";

import { c_dtable_permission_groups_module } from "./permission_groups/c_dtable_permission_groups_module";
import { c_dtable_division_list_module } from "./divisions/division_list/c_dtable_division_list_module"
import { c_dtable_division_detail_module } from "./divisions/division_detail/c_dtable_division_detail_module"
import { c_dtable_app_users_list_module } from "./app-users/app_users_list/c_dtable_app_users_list_module"
import { c_dtable_app_users_detail_module } from "./app-users/app_users_detail/c_dtable_app_users_detail_module"
import { c_dtable_app_users_sites_list_module } from "./app-users/app_users_sites_list/c_dtable_app_users_sites_list_module"
import { c_dtable_cloud_ai_stat_device_module } from "./analtics/video-ai-stat/device/c_dtable_cloud_ai_stat_device.module"
import { c_dtable_cloud_ai_stat_site_module } from "./analtics/video-ai-stat/site/c_dtable_cloud_ai_stat_site.module"
import { c_dtable_cloud_ai_stat_dealer_module } from "./analtics/video-ai-stat/dealer/c_dtable_cloud_ai_stat_dealer.module"
import { c_dtable_site_list_module } from "./analtics/site-note-manager/site-list/c_dtable_site_list.module";
import { c_dtable_service_note_module } from "./analtics/site-note-manager/service-note/c_dtable_service_note.module";
import { c_dtable_monitoring_portal_direction_module } from "./analtics/site-note-manager/monitoring-portal-direction/c_dtable_monitoring_portal_direction.module";
import { c_dtable_cloud_vms_manager_for_device_module } from "./cloud_vms_manager/device-table/c_dtable_cloud_vms_manager_for_device.module";
import { c_dtable_cloud_vms_manager_for_site_module } from "./cloud_vms_manager/site-table/c_dtable_cloud_vms_manager_for_site.module";
import { c_dtable_site_default_settings_for_new_site_module } from "./site_default_settings/new_site/c_dtable_site_default_settings_for_new_site.module";
import { c_dtable_site_default_settings_for_partition_module } from "./site_default_settings/partition/c_dtable_site_default_settings_for_partition.module";
import { c_dtable_plan_pricing_module } from "./plan-pricing/c_dtable_plan_pricing.module";
import { c_dtable_automated_incident_settings_module } from "./automated-incident/automated_incident-settings/c_dtable_automated_incident_settings_module";
import { c_dtable_automated_incident_detail_module } from "./automated-incident/automated_incident_detail/c_dtable_automated_incident_detail_module";
import { c_dtable_incident_reports_manager_module } from "./analtics/incident-reports-manager/c_dtable_incident_reports_manager.module";
import { c_dtable_device_health_module } from './analtics/device-health/c_dtable_device_health.module'
import { c_dtable_mp_sessions_manager_module } from "./analtics/mp-sessions-manager/c_dtable_mp_sessions_manager.module";
import { c_dtable_mp_session_code_detail_module } from "./mp-session-code/mp_session_code_detail/c_dtable_mp_session_code_detail_module";
import { c_dtable_mp_session_code_settings_module } from "./mp-session-code/mp_session_code_settings/c_dtable_mp_session_code_settings_module";

@NgModule({
  exports: [
    c_dtable_permission_groups_module,
    c_dtable_division_list_module,
    c_dtable_division_detail_module,
    c_dtable_app_users_list_module,
    c_dtable_app_users_detail_module,
    c_dtable_app_users_sites_list_module,
    c_dtable_cloud_ai_stat_device_module,
    c_dtable_cloud_ai_stat_site_module,
    c_dtable_cloud_ai_stat_dealer_module,
    c_dtable_site_list_module,
    c_dtable_service_note_module,
    c_dtable_monitoring_portal_direction_module,
    c_dtable_cloud_vms_manager_for_device_module,
    c_dtable_cloud_vms_manager_for_site_module,
    c_dtable_site_default_settings_for_new_site_module,
    c_dtable_site_default_settings_for_partition_module,
    c_dtable_plan_pricing_module,
    c_dtable_automated_incident_settings_module,
    c_dtable_automated_incident_detail_module,
    c_dtable_incident_reports_manager_module,
    c_dtable_device_health_module,
    c_dtable_mp_sessions_manager_module,
    c_dtable_mp_session_code_detail_module,
    c_dtable_mp_session_code_settings_module
  ]
})
export class c_dtable_module {}
